import { createAsyncThunk } from '@reduxjs/toolkit';
import blockUser from 'services/users/blockUser';

export const blockUserAction = createAsyncThunk('users/blockUser', async (uid) => {
  const result = await blockUser(uid);

  return result;
});
